export default __webpack_public_path__ + "static/media/triglycerides.61e216c1.svg";